const COMPONENT_NAME = "CardComposer";
const CATEGORY_TILE = "Category";
const AD_BUILDER_COMPONENT = "AdBuilder";
const COMPACT_PRODUCT_COMPONENT = "CompactProduct";
const INFORMATIVE_PRODUCT_COMPONENT = "InformativeProduct";
const FEATURE_HIGHLIGHT_COMPONENT = "FeatureHighlight";
export {
  AD_BUILDER_COMPONENT,
  CATEGORY_TILE,
  COMPACT_PRODUCT_COMPONENT,
  COMPONENT_NAME,
  FEATURE_HIGHLIGHT_COMPONENT,
  INFORMATIVE_PRODUCT_COMPONENT
};
